import { render, staticRenderFns } from "./i18nIndex.vue?vue&type=template&id=a63229ca"
import script from "./i18nIndex.vue?vue&type=script&lang=js"
export * from "./i18nIndex.vue?vue&type=script&lang=js"
import style0 from "./i18nIndex.vue?vue&type=style&index=0&id=a63229ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports